<template>
  <b-modal
    v-model="show"
    :size="size"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
  >
    <button
      class="d-lg-none btn btn-block btn-sm p-0 draggable-line mb-6"
      @click="close"
    />

    <div class="bp-dialog-content">
      <i :class="[icon, iconColor]" v-if="icon" class="fs-32" />

      <slot>
        <div class="my-4">
          {{ text }}
        </div>
      </slot>

      <bp-radio v-if="options.length" v-model="radioValue" :options="options" />

      <div class="w-100">
        <div class="row flex-column flex-lg-row">
          <div
            class="order-0 order-lg-1"
            :class="secondaryButtonText ? 'col-lg-6' : 'col-12'"
          >
            <bp-button
              v-bind="buttonVariant"
              block
              :label="buttonText"
              @click="action"
            />
          </div>

          <div class="col-lg-6" v-if="secondaryButtonText">
            <bp-button
              v-bind="secondaryButtonVariant"
              block
              :label="secondaryButtonText"
              @click="secondaryAction"
            />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md"
    },
    variant: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String
    },
    text: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: "Confirmar"
    },
    secondaryButtonText: {
      type: String
    }
  },
  data() {
    const radioValue = this.options?.length ? this.options[0].id : "";
    return {
      show: this.value,
      radioValue
    };
  },
  methods: {
    action() {
      this.$emit("action", this.radioValue);
      this.close();
    },
    secondaryAction() {
      this.$emit("secondary-action", this.radioValue);
      this.close();
    },
    close() {
      this.$emit("input", false);
    }
  },
  computed: {
    iconColor() {
      const iconColorMap = {
        alert: "text-alert-300",
        primary: "text-primary-400",
        positive: "text-positive-300",
        negative: "text-negative-400"
      };
      return iconColorMap[this.variant];
    },
    buttonVariant() {
      const buttonVariantMap = {
        alert: { color: "neutral", variant: "filled-1" },
        primary: { color: "primary", variant: "filled-1" },
        negative: { color: "neutral", variant: "filled-1" },
        positive: { color: "positive", variant: "filled-1" }
      };
      return buttonVariantMap[this.variant];
    },
    secondaryButtonVariant() {
      const secondaryButtonVariantMap = {
        alert: { color: "alert", variant: "glyph" },
        primary: { color: "neutral", variant: "glyph" },
        negative: {
          color: "negative",
          variant: "glyph",
          class: "text-negative-800"
        },
        positive: { color: "neutral", variant: "glyph" }
      };
      return secondaryButtonVariantMap[this.variant];
    }
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.bp-dialog-content {
  padding: 16px 16px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 24px;
}

.close-button {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  font-size: 14px;
  color: rgba(42, 42, 42, 1);
  background-color: rgba(215, 215, 215, 0.48);
  border-radius: 20px;
  transition: unset;
  &:hover {
    background-color: rgba(215, 215, 215, 0.76);
  }
}
</style>
